import {brandColors} from '@/products/flexible-web-toolkit/colors/brand-colors'
import {generalColors} from '@/products/flexible-web-toolkit/colors/general-colors'

export function getColorHex(colorKey: string): string | undefined {
	if (colorKey in generalColors) {
		return generalColors[colorKey]?.backgroundColor
	}

	if (colorKey in brandColors) {
		return brandColors[colorKey]?.backgroundColor
	}

	return undefined
}
